import useAuth from '@modules/AuthModule/hooks/useAuth';
import { useCallback } from 'react';
import { CONTACT_SUPPORT_EMAIL } from 'src/constants/contact-support';
import commonStrings from 'src/constants/strings';

type ContactSupportParams = {
  userName: string;
  userId: string;
  orgName: string;
  orgId: string;
  subject?: string;
};

export const contactSupport = ({
  userName,
  userId,
  orgName,
  orgId,
  subject = commonStrings.labels.contactSupport.subjectText,
}: ContactSupportParams) => {
  const encodedSubject = encodeURIComponent(
    `${subject} - ${orgName} - ${userName}`,
  );
  const encodedBody = encodeURIComponent(
    `User Name: ${userName}\nUser ID: ${userId}\nOrg Name: ${orgName}\nOrg Id: ${orgId}\n\n`,
  );
  const href = `mailto:${CONTACT_SUPPORT_EMAIL}?subject=${encodedSubject}&body=${encodedBody}`;
  window.open(href, '_blank', 'noopener,noreferrer');
};

export function useContactSupportButton() {
  const { user } = useAuth();

  const onSecondaryActionClick = useCallback(() => {
    contactSupport({
      userName: user?.name || 'Unknown User',
      userId: user?.id || 'Unknown ID',
      orgId: user?.org?.id || 'Unknown Organization ID',
      orgName: user?.org?.name || 'Unknown Organization',
    });
  }, [user]);

  return {
    secondaryActionName: commonStrings.labels.toasts.contactSupportActionText,
    onSecondaryActionClick,
  };
}
